import { useEffect, useState } from 'react'
import getDc3AttestationAssigned from 'api/administration/courses/GetDc3AttestationAssigned'

export const useDc3AttestationAssigned = (
  courseId?: number,
  enabled = true
) => {
  const [assigned, setAssigned] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled || !courseId) {
      setAssigned(false)
      return
    }

    let cancelled = false
    setLoading(true)

    getDc3AttestationAssigned(courseId)
      .then(({ assigned: isAssigned }) => {
        if (!cancelled) {
          setAssigned(isAssigned)
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAssigned(false)
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [courseId, enabled])

  return { assigned, loading }
}
